<script setup lang="ts">
	import SectionHeader from './ui/SectionHeader.vue'

	const importantInformation = [
		'El pago se procesará en México.',
		'Reconozco que he leído y acepto las condiciones específicas del hotel.',
	]

	const serviceContacts = [
		{
			name: 'Email',
			href: `mailto:${import.meta.env.VITE_MAIL_RESERVATION_NOTIFICATION_TO}`,
			icon: 'M3 8l7.89 3.26a2 2 0 001.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
		},
		{
			name: 'WhatsApp',
			href: `https://wa.me/${import.meta.env.VITE_WHATSAPP_RESERVATION_NOTIFICATION_TO}`,
			icon: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488',
		},
	]

	const serviceMapClass: Record<string, string> = {
		WhatsApp: 'bg-green-600 hover:bg-green-700',
		Email: 'bg-blue-600 hover:bg-blue-700',
	}
</script>

<template>
	<div
		class="bg-white rounded-xl border border-gray-200 overflow-hidden mx-auto w-full max-w-7xl mt-2 lg:mt-0"
	>
		<SectionHeader
			title="Información importante sobre su reserva"
			icon="info"
			icon-bg-color="amber"
			icon-color="amber"
		/>

		<div class="p-4 lg:p-6 space-y-3 lg:space-y-4">
			<ul
				class="space-y-2 text-base lg:text-sm text-gray-600 font-inter"
				v-for="info in importantInformation"
				:key="info"
			>
				<li class="flex items-start gap-2">
					<svg
						class="w-3 h-3 lg:w-4 lg:h-4 text-green-500 mt-0.5 flex-shrink-0"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M5 13l4 4L19 7"
						></path>
					</svg>
					<span>{{ info }}</span>
				</li>
			</ul>

			<div class="border-t border-gray-200 pt-3 lg:pt-4">
				<h4
					class="font-inter font-semibold text-sm lg:text-base text-gray-800 mb-2 lg:mb-3"
				>
					Servicio al cliente
				</h4>
				<p class="text-xs lg:text-sm text-gray-600 font-inter mb-3">
					¿Necesita ayuda con su transacción? Puede contactarnos a través de
				</p>
				<div class="flex flex-col md:flex-row gap-2 lg:gap-3">
					<a
						v-for="service in serviceContacts"
						:key="service.name"
						:target="service.name === 'WhatsApp' ? '_blank' : '_self'"
						:href="service.href"
						class="flex items-center justify-center gap-3 px-4 py-3 rounded-lg transition-colors w-full md:w-auto"
						:class="serviceMapClass[service.name]"
					>
						<svg
							class="w-3 h-3 lg:w-4 lg:h-4 text-white flex-shrink-0"
							:fill="service.name === 'WhatsApp' ? 'currentColor' : 'none'"
							:stroke="service.name === 'WhatsApp' ? 'none' : 'currentColor'"
							viewBox="0 0 24 24"
						>
							<path
								:stroke-linecap="
									service.name === 'WhatsApp' ? undefined : 'round'
								"
								:stroke-linejoin="
									service.name === 'WhatsApp' ? undefined : 'round'
								"
								:stroke-width="service.name === 'WhatsApp' ? undefined : 2"
								:d="service.icon"
							></path>
						</svg>

						<p class="text-white font-inter font-medium text-base lg:text-sm">
							{{ service.name }}
						</p>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
